export var ConstaStatus;
(function (ConstaStatus) {
    ConstaStatus["ALERT"] = "alert";
    ConstaStatus["WARNING"] = "warning";
    ConstaStatus["NORMAL"] = "normal";
    ConstaStatus["SUCCESS"] = "success";
})(ConstaStatus || (ConstaStatus = {}));
export var ConstaDragAndDropStatus;
(function (ConstaDragAndDropStatus) {
    ConstaDragAndDropStatus["ALERT"] = "alert";
    ConstaDragAndDropStatus["WARNING"] = "warning";
    ConstaDragAndDropStatus["SUCCESS"] = "success";
    ConstaDragAndDropStatus["DEFAULT"] = "default";
})(ConstaDragAndDropStatus || (ConstaDragAndDropStatus = {}));
export var ConstaViewTypes;
(function (ConstaViewTypes) {
    ConstaViewTypes["PRIMARY"] = "primary";
    ConstaViewTypes["ALERT"] = "alert";
    ConstaViewTypes["WARNING"] = "warning";
})(ConstaViewTypes || (ConstaViewTypes = {}));
export var ConstaBadgeStatus;
(function (ConstaBadgeStatus) {
    ConstaBadgeStatus["ERROR"] = "error";
    ConstaBadgeStatus["WARNING"] = "warning";
    ConstaBadgeStatus["SUCCESS"] = "success";
    ConstaBadgeStatus["NORMAL"] = "normal";
    ConstaBadgeStatus["SYSTEM"] = "system";
})(ConstaBadgeStatus || (ConstaBadgeStatus = {}));
